import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { adminResetPassword } from '../api';

const AdminResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (pw.length < 8) return setErr('Password must be at least 8 characters.');
    if (pw !== confirm) return setErr('Passwords do not match.');
    setBusy(true);
    try {
      await adminResetPassword(token, pw);
      setDone(true);
      setTimeout(() => navigate('/admin'), 2200);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || 'Could not reset password.');
    } finally { setBusy(false); }
  };

  return (
    <div className="pt-40 pb-40 min-h-screen">
      <div className="max-w-sm mx-auto px-5 card-glass rounded-2xl p-8">
        <h1 className="font-cinzel text-2xl text-gold-gradient text-center mb-1">Set New Password</h1>
        {!token ? (
          <p data-testid="admin-reset-notoken" className="text-[#ff4da6] text-sm font-jost text-center mt-4">This reset link is missing its token. Please use the link from your email.</p>
        ) : done ? (
          <p data-testid="admin-reset-done" className="text-[#a7f3d0] text-sm font-jost text-center mt-4">Password updated. Redirecting to the Owner Portal…</p>
        ) : (
          <form onSubmit={submit}>
            <p className="text-center text-[#f5ecd9]/50 text-xs font-jost mb-6">Choose a new Owner Portal password.</p>
            <input data-testid="admin-reset-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password (min 8 chars)" className="w-full bg-white/5 border border-[#d4af37]/30 rounded-md px-4 py-3 text-sm text-[#f5ecd9] focus:outline-none focus:border-[#ff4da6]" />
            <input data-testid="admin-reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm password" className="w-full mt-3 bg-white/5 border border-[#d4af37]/30 rounded-md px-4 py-3 text-sm text-[#f5ecd9] focus:outline-none focus:border-[#ff4da6]" />
            {err && <p data-testid="admin-reset-err" className="text-[#ff4da6] text-xs mt-2 font-jost">{err}</p>}
            <button data-testid="admin-reset-submit" disabled={busy} type="submit" className="btn-gold w-full mt-4 rounded-md py-3 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#d4af37] via-[#f0d582] to-[#d4af37] disabled:opacity-60">{busy ? 'Updating…' : 'Update password'}</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminResetPassword;
